import React from"react";
import "./about.css";

export default function About(){
    return (
        <div id="About" className="about">
            <div className="aboutTitle">
                <h1>about me</h1>
                <img src="/images/back.png" alt=""/>
            </div>
            <div className="aboutSection">
                <div className="aboutLeft">
                    <img src="/images/me.jpg" alt=""/>
                </div>
                <div className="aboutRight">
                    <div className="aboutPara">
                        <p>I have learned Frontend in youtube</p>
                        <p>My passion for front end development is not only reflcted in my extensive expression but also in the enthusiasm and dedication I bring to each project</p>
                    </div>
                    <div className="aboutSkills">
                        <div className="aboutSkill"><p>HTML and CSS</p><hr style={{width:"50%"}}/></div>
                        <div className="aboutSkill"><p>React JS</p><hr style={{width:"50%"}}/></div>
                        <div className="aboutSkill"><p>Node JS</p><hr style={{width:"45%"}}/></div>
                        <div className="aboutSkill"><p>MySql</p><hr style={{width:"45%"}}/></div>
                        <div className="aboutSkill"><p>BootStrap</p><hr style={{width:"30%"}}/></div>
                        <div className="aboutSkill"><p>Python</p><hr style={{width:"50%"}}/></div>
                        <div className="aboutSkill"><p>C/C++</p><hr style={{width:"40%"}}/></div>
                        <div className="aboutSkill"><p>Java</p><hr style={{width:"45%"}}/></div>

                    </div>
                </div>
            </div>
            <div className="aboutAchievements">
                <div className="aboutAchievement">
                    <h1>50+</h1>
                    <p>DSA problems solved</p>
                </div>
                <hr />
                <div className="aboutAchievement">
                    <h1>10+</h1>
                    <p>websites</p>
                </div>
            </div>
        </div>
    )
}